import React, { useState } from "react";
import Dialog from "./Dialog";
import RewardBackground from "../../assets/images/weekly star image/gift-bg-1 1.png";
import Rank1 from "../../assets/images/weekly star image/top1 1.png";
import Rank2 from "../../assets/images/weekly star image/top2 3.png";
import Rank3 from "../../assets/images/weekly star image/top3 1.png";
import coin from "../../assets/images/weekly star image/coin 3.png";
import DialogButton from "../../assets/images/weekly star image/rulesButton.png";
import activeTabBar from "../../assets/images/weekly star image/active.png";
import tabBar from "../../assets/images/weekly star image/desctiv.png";
import fallbackImage2 from "../../assets/icons/gift-box 1.png";
import imageRing from "../../assets/images/New folder/ic_golden_ring 1.png";

import fallbackImage1 from "../../assets/images/weekly star image/Ellipse 1 (1).png";

import { useTranslation } from "react-i18next";
import TimerComponent from "./TimerComponent";
import { Link } from "react-router-dom";
import RewardDialog from "../pk/RewardDialog";

const Design = ({
  senderGiftTop,
  topDetails,
  roleEventData,
  userGiftsTop,
  userGiftsTopHours,
  topWeeklyData,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [activeGiftId, setActiveGiftId] = useState(null);
  const imageBaseUrl = "https://media.smolivechat.com/";
  const [imageErrors, setImageErrors] = useState({});
  const [imageErrors1, setImageErrors1] = useState({});
  const [imageErrors2, setImageErrors2] = useState({});
  const [imageErrors3, setImageErrors3] = useState({});

  // Handle image error by updating the imageErrors state
  const handleError = (itemId) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [itemId]: true, // Mark this item image as failed to load
    }));
  };
  const handleError1 = (imagePath) => {
    setImageErrors1((prevState) => ({
      ...prevState,
      [imagePath]: true, // mark this path as failed
    }));
  };
  const handleError2 = (imagePath) => {
    setImageErrors2((prevState) => ({
      ...prevState,
      [imagePath]: true, // mark this path as failed
    }));
  };
  const handleError3 = (imagePath) => {
    setImageErrors3((prevState) => ({
      ...prevState,
      [imagePath]: true, // mark this path as failed
    }));
  };
  const { t } = useTranslation();

  // Reusable Score Badge Component
  const ScoreBadge = ({ score }) => (
    <p className="px-5 flex flex-row items-center justify-center gap-1 text-[#C6A9FF] font-cairo font-medium text-[20px] leading-[23px] text-center">
      <img src={coin} alt="coin" className=" " />
      {parseInt(score) || "--"}
    </p>
  );

  // Reusable Avatar Image Component
  const AvatarImage = ({ imageUrl, size = "w-14 h-14" }) => (
    <div className="relative group">
      <img
        src={imageRing}
        className={` w-16  h-16  z-40 absolute top-0 left-0 rounded-full   shadow-xl   object-cover transform group-hover:scale-110 transition-transform duration-300 `}
        alt="avatar"
      />{" "}
      <img
        src={
          imageErrors[imageUrl] ? fallbackImage1 : `${imageBaseUrl}${imageUrl}`
        }
        onError={() => handleError(imageUrl)}
        className={`${size} rounded-full   shadow-xl relative z-10 object-cover transform group-hover:scale-110 transition-transform duration-300 `}
        alt="avatar"
      />
    </div>
  );

  // Reusable Winner List Item Component
  const WinnerListItem = ({ item, position }) => (
    <div className="w-full h-[86px] my-1 p-2 rounded-xl [background:linear-gradient(93.2deg,#5E1589_45.22%,#4A1474_88.28%)]">
      <div className="flex flex-row justify-between items-center h-full">
        <div className="w-[70%] flex flex-row items-center">
          <p className="font-cairo font-semibold w-[15%] text-[22px] leading-[26px] flex items-center text-right text-[#C6A9FF]">
            {position}
          </p>
          <div className="relative flex flex-row items-center gap-2">
            <AvatarImage imageUrl={item.avatar} size="w-16  h-16  " />
            <div className="px-2">
              <p className="text-[#C6A9FF] font-cairo font-medium text-[20px] leading-[23px] flex items-center text-right">
                {item.name}
              </p>
            </div>
          </div>
        </div>
        <div className="w-[25%] flex flex-row justify-end items-center">
          <ScoreBadge score={item.totalGiftNum} />
        </div>
      </div>
    </div>
  );

  // Reusable Winners List Component
  const WinnersList = ({ winners }) => {
    if (!winners || winners.length === 0) return null;

    return (
      <div className="mx-auto w-[100%]  pt-14  flex flex-col relative">
        {winners.map((item, index) => (
          <WinnerListItem key={index} item={item} position={index + 4} />
        ))}
      </div>
    );
  };

  // Ranking Card Component
  const RankingCard = ({ rank, userData, rankImage, className = "" }) => {
    const rankConfig = {
      1: {
        containerHeight: "h-[250px]",
        avatarSize: "w-[100px] h-[100px]",
        avatarPosition: "top-[72px]",
        contentPosition: "-bottom-10",
        textSize: { name: "text-sm", id: "text-sm", gifts: "text-sm" },
        nameTextClass:
          "text-[#2E0B45] text-[18px] leading-[28px] font-bold justify-center text-center [text-shadow:0_1px_2px_rgba(255,236,170,0.85),0_0_6px_rgba(255,236,170,0.6)]",
      },
      2: {
        containerHeight: "h-[150px]",
        containerWeight: "w-[160px]",

        avatarSize: "w-[80px] h-[80px]",
        avatarPosition: "top-11",
        contentPosition: "bottom-[-38px]",
        textSize: { name: "text-xs", id: "text-xs", gifts: "text-xs" },
        nameTextClass:
          "text-[#C6A9FF] text-[16px] leading-[23px] font-semibold justify-center text-center",
      },
      3: {
        containerHeight: "h-[150px]",
        containerWeight: "w-[160px]",

        avatarSize: "w-[80px] h-[80px]",
        avatarPosition: "top-11",
        contentPosition: "bottom-[-38px]",
        textSize: { name: "text-xs", id: "text-xs", gifts: "text-xs" },
        nameTextClass:
          "text-[#C6A9FF] text-[16px] leading-[23px] font-semibold justify-center text-center",
      },
    };

    const config = rankConfig[rank];

    if (!userData) return null;

    return (
      <div
        className={`relative pop-in ${className}`}
        style={{ animationDelay: `${rank === 1 ? 0 : (rank - 1) * 120}ms` }}
      >
        <img
          src={rankImage}
          alt={`Rank ${rank}`}
          className={`${config.containerHeight} ${config.containerWeight} mx-auto  relative z-30 object-cover rounded-2xl`}
        />

        <img
          src={
            imageErrors1[userData?.avatar] // ✅ if error, use fallback
              ? fallbackImage2
              : `${imageBaseUrl}${userData?.avatar}`
          }
          onError={() => handleError1(userData?.avatar)} // ✅ just pass image path
          alt={userData?.name}
          className={`absolute ${config.avatarPosition} left-1/2 z-10 transform -translate-x-1/2 rounded-full ${config.avatarSize} object-cover shadow-lg`}
        />

        <div
          className={`absolute ${config.contentPosition} w-full z-30 pt-5 px-2`}
        >
          {(rank === 2 || rank === 3) && (
            <div className="absolute left-1/2 top-1/2 mt-3 -translate-x-1/2 -translate-y-1/2 w-[155px] h-[53px] -z-10 backdrop-blur-[2px] [background:linear-gradient(90deg,rgba(87,21,104,0)_0%,#571568_48.56%,rgba(87,21,104,0)_100%)]" />
          )}
          <p
            className={`font-cairo w-[100%] mx-auto truncate flex items-center ${config.nameTextClass}`}
          >
            {userData?.name}
          </p>

          <p className="text-[#4E1C62] font-cairo font-semibold text-[16px] leading-[23px] flex flex-row justify-center gap-1 items-center text-center">
            <img src={coin} alt="coin" className="" />
            <span className={config.nameTextClass}>
              {" "}
              {userData?.totalGiftNum}
            </span>
          </p>
        </div>
      </div>
    );
  };
  // Ranking Card Component
  const RankingCard1 = ({ rank, userData, rankImage, className = "" }) => {
    const rankConfig = {
      1: {
        containerHeight: "h-[261px]",
        avatarSize: "w-[65px] h-[60px]",
        avatarPosition: "top-[72px]",
        contentPosition: "bottom-12",
        textSize: { name: "text-sm", id: "text-sm", gifts: "text-sm" },
      },
      2: {
        containerHeight: "h-[195px]",
        containerWeight: "w-[165px]",

        avatarSize: "w-[65px] h-[65px]",
        avatarPosition: "top-8",
        contentPosition: "bottom-9",
        textSize: { name: "text-[12px]", id: "text-xs", gifts: "text-[12px]" },
      },
      3: {
        containerHeight: "h-[195px]",
        containerWeight: "w-[165px]",

        avatarSize: "w-[65px] h-[65px]",
        avatarPosition: "top-8",
        contentPosition: "bottom-9",
        textSize: { name: "text-[12px]", id: "text-xs", gifts: "text-[12px]" },
      },
    };

    const config = rankConfig[rank];

    if (!userData) return null;
    return (
      <div
        className={`relative pop-in ${className}`}
        style={{ animationDelay: `${rank === 1 ? 0 : (rank - 1) * 120}ms` }}
      >
        <img
          src={rankImage}
          alt={`Rank ${rank}`}
          className={`${config.containerHeight} ${config.containerWeight} mx-auto  relative z-30 object-cover rounded-2xl`}
        />

        <img
          src={
            imageErrors2[userData?.photo] // ✅ if error, use fallback
              ? fallbackImage2
              : `${imageBaseUrl}${userData?.photo}`
          }
          onError={() => handleError2(userData?.photo)} // ✅ just pass image path
          alt={userData?.sender_name}
          className={`absolute ${config.avatarPosition} left-1/2 z-10 transform -translate-x-1/2 rounded-xl   ${config.avatarSize} object-cover shadow-lg`}
        />

        <div className={`absolute ${config.contentPosition} w-full z-30 px-2`}>
          <p
            className={`text-white font-semibold truncate ${config.textSize.name}`}
          >
            {userData?.sender_name}
          </p>
          <p className={`text-white ${config.textSize.id}`}>
            ID: {userData?.sender_id}
          </p>
          <p
            className={`gradientText font-semibold ${config.textSize.gifts} text-[12px] flex flex-row font-cairo justify-center gap-1 items-center text-center font-extrabold gradientText  `}
          >
            <img src={coin} alt="coin" className="h-[13px]" />
            <span> {userData?.totalGiftNum}</span>
          </p>
        </div>
      </div>
    );
  };
  // Ranking Container Component
  const RankingContainer = ({ data = [], rankImages = {} }) => {
    return (
      <div className="flex flex-col justify-center items-center w-full text-center gap-2">
        {data.map((period, idx) => {
          const rankedData = [
            ...(period.userTop || []),
            null,
            null,
            null,
          ].slice(0, 3);

          return (
            <div
              key={idx}
              className="RangeBackground xxs:h-[630px] relative sm:h-[680px] pt-[40px] flex flex-col justify-center items-center text-center w-full"
            >
              <h2 className="gradientText font-bold text-[13px] mb-3  sm:top-[-23px]  xxs:top-[-10px] relative">
                {period.time}
              </h2>

              <div className="relative w-full">
                <RankingCard1
                  rank={1}
                  userData={rankedData[0]}
                  rankImage={rankImages[1]}
                />
              </div>

              <div className="flex flex-row relative top-3 justify-between items-center gap-4 w-full">
                {[2, 3].map((rank) => (
                  <div key={rank} className="relative flex-1">
                    <RankingCard1
                      rank={rank}
                      userData={rankedData[rank - 1]}
                      rankImage={rankImages[rank]}
                    />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // Rank images mapping
  const rankImages = {
    1: Rank1,
    2: Rank2,
    3: Rank3,
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "tab1":
        return (
          <div className="tab-panel   relative top-[-40px]  flex flex-col justify-center gap-5 items-center text-center">
            <div className="  flex flex-row justify-between items-center w-full   h-[172px] relative">
              <div className="flex flex-row items-center justify-between  pt-24 w-full ">
                {(() => {
                  const giftsArr = roleEventData?.weekly_event?.gifts || [];
                  const midIndex = Math.floor((giftsArr.length - 1) / 2);
                  const currentActiveId =
                    activeGiftId ?? giftsArr[midIndex]?.id;
                  const activeGift = giftsArr.find(
                    (g) => g.id === currentActiveId,
                  );
                  const others = giftsArr.filter(
                    (g) => g.id !== currentActiveId,
                  );
                  const displayGifts = activeGift
                    ? [
                        ...others.slice(0, midIndex),
                        activeGift,
                        ...others.slice(midIndex),
                      ]
                    : giftsArr;

                  return displayGifts.map((gift) => {
                    const isActive = gift.id === currentActiveId;
                    return (
                      <div
                        key={gift.id}
                        onClick={() => setActiveGiftId(gift.id)}
                        className={`rounded-2xl flex flex-col items-center transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] cursor-pointer ${
                          isActive
                            ? "w-[120px] h-[170px] -translate-y-3 z-10"
                            : "w-[90px] h-[140px] opacity-80"
                        }`}
                      >
                        <div
                          className={`relative transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] ${
                            isActive
                              ? "w-[120px] h-[120px]"
                              : "w-[85px] h-[85px]"
                          }`}
                        >
                          <img
                            src={RewardBackground}
                            alt="reward background"
                            className="absolute inset-0 w-full h-full"
                          />
                          <img
                            src={
                              imageErrors[gift?.image]
                                ? fallbackImage2
                                : `${imageBaseUrl}${gift?.image}`
                            }
                            alt={gift.name}
                            onError={() => handleError(gift?.image)}
                            className="absolute inset-2 rounded-xl w-[calc(100%-16px)] h-[calc(100%-16px)] object-cover"
                          />
                        </div>
                        {isActive ? (
                          <div
                            key={`${gift.id}-active`}
                            className="pop-in flex flex-row justify-center gap-1.5 items-center bg-black/60 border border-white/30 rounded-lg px-3 py-1 mt-2"
                            style={{ animationDuration: "0.25s" }}
                          >
                            <img src={coin} alt="coin" className="h-5 w-5" />
                            <span className="text-white text-sm font-bold">
                              {gift?.price}
                            </span>
                          </div>
                        ) : (
                          <div
                            key={`${gift.id}-inactive`}
                            className="pop-in flex flex-row justify-center gap-1 items-center mt-2"
                            style={{ animationDuration: "0.25s" }}
                          >
                            <img src={coin} alt="coin" className="h-4 w-4" />
                            <span className="text-white/70 text-xs font-medium">
                              {gift?.price}
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  });
                })()}
              </div>
            </div>
            <div className=" w-[95%] mx-auto ">
              {/* Remove overflow-hidden here */}
              <div>
                {/* Only this one should scroll */}
                <div className="  overflow-y-auto h-full w-full mx-auto">
                  <div className="relative  flex flex-col pt-11 justify-center items-center text-center w-full">
                    <div className="relative w-full">
                      <RankingCard
                        rank={1}
                        userData={userGiftsTop?.top?.[0]}
                        rankImage={rankImages[1]}
                      />
                    </div>

                    <div className="flex flex-row relative   pt-14 pb-6 justify-between items-center gap-4 w-full">
                      {[2, 3].map((rank) => (
                        <div key={rank} className="relative flex-1">
                          <RankingCard
                            rank={rank}
                            userData={userGiftsTop?.top?.[rank - 1]}
                            rankImage={rankImages[rank]}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  <WinnersList winners={userGiftsTop?.top.slice(3)} />
                </div>
              </div>
            </div>
          </div>
        );

      case "tab2":
        return (
          <div className="tab-panel relative top-[-40px] flex flex-col justify-center items-center text-center gap-10">
            {senderGiftTop && (
              <RankingContainer data={senderGiftTop} rankImages={rankImages} />
            )}
          </div>
        );

      case "tab3":
        return (
          <div className=" relative top-[-40px] tab-panel">
            <div className="pt-7 overflow-hidden relative flex flex-col items-center text-center">
              <div className="  w-full mx-auto">
                {[
                  {
                    title: t("Top 1"),
                    rewards: topDetails?.top_1,
                  },
                  {
                    title: t("Top 2"),
                    rewards: topDetails?.top_2,
                  },
                  {
                    title: t("Top 3"),
                    rewards: topDetails?.top_3,
                  },
                ].map((section, sectionIndex) => (
                  <div
                    key={sectionIndex}
                    className=" WeeklyRewardBackGround w-[100%] mb-8"
                  >
                    <div className="relative w-[60%] mx-auto mb-4">
                      <p className="absolute top-[36px] left-1/2 -translate-x-1/2 flex items-center justify-center text-[20px] leading-[23px] tracking-normal font-semibold text-[#FFE79D] [text-shadow:0px_4px_4px_rgba(0,0,0,0.25)]">
                        {section.title}
                      </p>
                    </div>

                    <div className="rounded-2xl top-[25%] p-2 relative my-3">
                      <div className="flex flex-wrap justify-center gap-1">
                        {section.rewards?.length > 0 ? (
                          section.rewards.map((item, index) => (
                            <div
                              key={`${item.id || item.name}-${index}`}
                              className="rounded-2xl w-[120px] h-[130px] flex flex-col items-center"
                            >
                              <div className="relative">
                                <img
                                  src={RewardBackground}
                                  alt="reward background"
                                  className="w-[100px] h-[100px] "
                                />
                                <img
                                  src={
                                    imageErrors3[item?.image]
                                      ? fallbackImage2
                                      : `${imageBaseUrl}${item?.image}`
                                  }
                                  alt={item.name}
                                  onError={() => handleError3(item?.image)}
                                  className="absolute inset-0 m-auto rounded-full w-[70px] h-[70px] object-cover shadow-md"
                                />
                              </div>
                              <p className="text-[10px] font-cairo font-bold w-full text-center gradientText mt-2">
                                {item.name}
                              </p>
                            </div>
                          ))
                        ) : (
                          <p className="text-xs font-medium text-white py-3">
                            {t("no data available")}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="bg-[#000002] relative overflow-hidden  ">
      <div className="weeklyStar relative">
        <Dialog
          isOpen={isDialogOpen}
          closeDialog={closeDialog}
          description={roleEventData?.weekly_event?.description}
        />

        <div className="absolute top-[15%] z-[9999] right-0">
          <div
            onClick={openDialog}
            className="relative inline-block cursor-pointer"
          >
            <img
              src={DialogButton}
              alt="rules"
              className=" w-[80px] md:[200px] h-[50px]"
            />
            <p className="absolute font-cairo font-bold top-[47%] left-[68%] transform -translate-x-1/2 -translate-y-1/2 gradientText text-base md:text-3xl  leading-[48.32px] text-center">
              {t("Rules")}
            </p>
          </div>
        </div>
      </div>
      <div className="relative top-[-50px] w-full">
        {roleEventData?.weekly_event?.remainingTime && (
          <TimerComponent
            initialTime={roleEventData.weekly_event.remainingTime}
          />
        )}
      </div>
      <div className="weeklyStarBgReward">
        <div className="flex z-20  relative top-[-55px] w-full mx-auto items-center justify-around">
          {[
            { id: "tab3", label: "Rewards", wide: true },
            { id: "tab1", label: "Weekly ranking", wide: false },
          ].map((tab) => (
            <div
              key={tab.id}
              className={`inline-block relative w-[40%] cursor-pointer transition-all duration-200 ease-[cubic-bezier(0.34,1.56,0.64,1)] ${
                activeTab === tab.id ? "active scale-105" : "hover:scale-102"
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              <img
                src={activeTab === tab.id ? activeTabBar : tabBar}
                alt={`${tab.label} tab`}
                className="w-[142px] h-[58px] object-cover"
              />
              <p
                className={`absolute w-full top-1/2 left-[44%] transform font-cairo font-semibold -translate-x-1/2 flex items-center justify-center text-center text-[16px] leading-[23px] [text-shadow:0px_0px_4px_rgba(0,0,0,0.25)] ${
                  tab.wide
                    ? "w-[80%] xs:-translate-y-[53%]"
                    : "xs:-translate-y-[68%]"
                } ${
                  activeTab === tab.id
                    ? "text-[#420041]"
                    : "text-[rgba(255,251,255,0.4)]"
                }`}
              >
                {t(tab.label)}
              </p>
            </div>
          ))}
        </div>

        <div key={activeTab} className="tab-content-in">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default Design;
